export default __webpack_public_path__ + "static/media/marquee6.00e24900.png";